module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112554735.3da9ef7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112554735.jpg
// module id = 44
// module chunks = 0